



import React from 'react';
import { useNavigate } from "react-router-dom";
import { FaUserPlus, FaSignInAlt } from 'react-icons/fa'; // أيقونات من React Icons

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-cover bg-center" style={{ backgroundImage: "url('./images/photo2.jpg')" }}>
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60 z-0" />

      {/* Header */}
      <div className="relative z-10 flex justify-between items-center p-6 text-white">
      <div className="flex items-center gap-2">
  <img src="./images/logo1.png" alt="Tazkarti Logo" className="w-10 h-10 rounded-full" />
  <span className="text-2xl font-bold">Ticket</span>
</div>

        <div className="space-x-6 flex items-center">
          <button onClick={() => navigate('/register')} className="hover:underline flex items-center gap-1">
            <FaUserPlus /> انشاء حساب
          </button>
          <button onClick={() => navigate('/login')} className="hover:underline flex items-center gap-1">
            <FaSignInAlt /> تسجيل دخول
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 flex flex-col items-center justify-center text-white text-center mt-20 px-4">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">ما هي خطتك القادمة؟</h1>
        <p className="text-lg mb-8">استكشف واحجز جميع الأحداث الحصرية
   </p>

        {/* Entertainment Card */}
        <div
          className="bg-orange-600 hover:bg-orange-700 cursor-pointer rounded-lg p-6 text-white shadow-lg transition"
          onClick={() => navigate("/home")}
        >
          <div className="text-3xl mb-2">🍿</div>
          <div className="text-xl font-semibold">Entertainment</div>
          <div className="text-sm">Event Tickets</div>
        </div>

        {/* Auth Buttons */}
        <div className="mt-10 text-white text-sm">
          <span
            className="font-semibold cursor-pointer hover:underline"
            onClick={() => navigate('/login')}
          >
            Sign in
          </span> OR
          <button
            className="ml-2 bg-green-600 hover:bg-green-700 px-4 py-2 rounded font-semibold"
            onClick={() => navigate('/register')}
          >
            Register Now!
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white text-xs z-10">
        © 2025 Team. All rights reserved. Developed and Powered by Team.
      </div>
    </div>
  );
}
